export default {
    async SET_EMAIL(state, email) {
        state.email = email;
    }
};
